__turbopack_context__.v({
  "cardDescription": "TakeawayPageView-module__LoOXOq__cardDescription",
  "cardGrid": "TakeawayPageView-module__LoOXOq__cardGrid",
  "cardTitle": "TakeawayPageView-module__LoOXOq__cardTitle",
  "categoryHeader": "TakeawayPageView-module__LoOXOq__categoryHeader",
  "categoryKicker": "TakeawayPageView-module__LoOXOq__categoryKicker",
  "categoryPanel": "TakeawayPageView-module__LoOXOq__categoryPanel",
  "contactButton": "TakeawayPageView-module__LoOXOq__contactButton",
  "contactCard": "TakeawayPageView-module__LoOXOq__contactCard",
  "contactDetails": "TakeawayPageView-module__LoOXOq__contactDetails",
  "dayHours": "TakeawayPageView-module__LoOXOq__dayHours",
  "dayLabel": "TakeawayPageView-module__LoOXOq__dayLabel",
  "detailItem": "TakeawayPageView-module__LoOXOq__detailItem",
  "detailSection": "TakeawayPageView-module__LoOXOq__detailSection",
  "dishContent": "TakeawayPageView-module__LoOXOq__dishContent",
  "dishList": "TakeawayPageView-module__LoOXOq__dishList",
  "dishRow": "TakeawayPageView-module__LoOXOq__dishRow",
  "dishTitleRow": "TakeawayPageView-module__LoOXOq__dishTitleRow",
  "emptyMenu": "TakeawayPageView-module__LoOXOq__emptyMenu",
  "eyebrow": "TakeawayPageView-module__LoOXOq__eyebrow",
  "hero": "TakeawayPageView-module__LoOXOq__hero",
  "heroActions": "TakeawayPageView-module__LoOXOq__heroActions",
  "heroContent": "TakeawayPageView-module__LoOXOq__heroContent",
  "heroDescription": "TakeawayPageView-module__LoOXOq__heroDescription",
  "heroGrid": "TakeawayPageView-module__LoOXOq__heroGrid",
  "heroImage": "TakeawayPageView-module__LoOXOq__heroImage",
  "heroImageFrame": "TakeawayPageView-module__LoOXOq__heroImageFrame",
  "heroTitle": "TakeawayPageView-module__LoOXOq__heroTitle",
  "heroVisual": "TakeawayPageView-module__LoOXOq__heroVisual",
  "liveNote": "TakeawayPageView-module__LoOXOq__liveNote",
  "menuSection": "TakeawayPageView-module__LoOXOq__menuSection",
  "page": "TakeawayPageView-module__LoOXOq__page",
  "primaryButton": "TakeawayPageView-module__LoOXOq__primaryButton",
  "scheduleBadge": "TakeawayPageView-module__LoOXOq__scheduleBadge",
  "scheduleCard": "TakeawayPageView-module__LoOXOq__scheduleCard",
  "scheduleList": "TakeawayPageView-module__LoOXOq__scheduleList",
  "scheduleRow": "TakeawayPageView-module__LoOXOq__scheduleRow",
  "secondaryButton": "TakeawayPageView-module__LoOXOq__secondaryButton",
  "secondaryNote": "TakeawayPageView-module__LoOXOq__secondaryNote",
  "sectionDescription": "TakeawayPageView-module__LoOXOq__sectionDescription",
  "sectionIntro": "TakeawayPageView-module__LoOXOq__sectionIntro",
  "sectionIntroCentered": "TakeawayPageView-module__LoOXOq__sectionIntroCentered",
  "sectionTitle": "TakeawayPageView-module__LoOXOq__sectionTitle",
  "serviceCard": "TakeawayPageView-module__LoOXOq__serviceCard",
  "serviceIcon": "TakeawayPageView-module__LoOXOq__serviceIcon",
  "serviceSection": "TakeawayPageView-module__LoOXOq__serviceSection",
  "stepCard": "TakeawayPageView-module__LoOXOq__stepCard",
  "stepNumber": "TakeawayPageView-module__LoOXOq__stepNumber",
  "stepsGrid": "TakeawayPageView-module__LoOXOq__stepsGrid",
  "stepsSection": "TakeawayPageView-module__LoOXOq__stepsSection",
  "summaryCard": "TakeawayPageView-module__LoOXOq__summaryCard",
  "summaryDescription": "TakeawayPageView-module__LoOXOq__summaryDescription",
  "summaryEyebrow": "TakeawayPageView-module__LoOXOq__summaryEyebrow",
  "summaryTitle": "TakeawayPageView-module__LoOXOq__summaryTitle",
  "takeawayCatalog": "TakeawayPageView-module__LoOXOq__takeawayCatalog",
});
